import React, { useState, useEffect, useContext, useRef } from 'react';
import APIConfig from '../../Common/Configurations/APIConfig';
import SearchSightSeeingPanel from './SearhSightSeeingPanel';
import './Sightseeing.css'; // Import the new CSS file
import { LandingContext } from '../Profile/LandingContext'; // Import the context
import DefaultData from '../../CompanyData/DefaultData';

const useInView = (options) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.unobserve(entry.target);
            }
        }, options);
        if (ref.current) { observer.observe(ref.current); }
        return () => {
            if (ref.current) { observer.unobserve(ref.current); }
        };
    }, [ref, options]);
    return [ref, inView];
};

const SearchSightSeeing = () => {
    const landingData = useContext(LandingContext);
    const [currency, setCurrency] = useState(DefaultData.DEFAULTCURRENCY);
    const handleCurrencyChange = (newCurrency) => {
        setCurrency(newCurrency);
    };

    // Refs for scroll animations
    const [offersRef, offersInView] = useInView({ threshold: 0.1 });
    const [destinationsRef, destinationsInView] = useInView({ threshold: 0.1 });
    
    // Mock Data for Sightseeing
    // In your SearchSightSeeing.js component

const sightseeingDeals = [
    { 
        brand: 'City Tours', 
        logoUrl: 'https://api.iconify.design/material-symbols/location-city.svg?color=%23198754', 
        title: 'Historic City Walks', 
        description: 'Explore iconic landmarks with our guided tours.', 
        discount: 'Up to 20% OFF', 
        type: 'percent' 
    },
    { 
        brand: 'Adventure', 
        logoUrl: 'https://api.iconify.design/material-symbols/filter-hdr.svg?color=%230d6efd', 
        title: 'Adrenaline Rush', 
        description: 'Book thrilling activities like zip-lining and rafting.', 
        discount: 'Flat ₹2000 OFF', 
        type: 'flat' 
    },
    { 
        brand: 'Theme Parks', 
        logoUrl: 'https://api.iconify.design/material-symbols/celebration.svg?color=%23fd7e14', 
        title: 'Family Fun Day', 
        description: 'Get your tickets to the most popular theme parks.', 
        discount: 'Starting @ ₹1,999', 
        type: 'price' 
    },
];
    const popularActivities = [
        { name: 'Paris, France', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8RnJhbmNlfGVufDB8fDB8fHww' },
        { name: 'Rome, Italy', image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?q=80&w=1996' },
        { name: 'Kyoto, Japan', image: 'https://images.unsplash.com/photo-1528164344705-47542687000d?q=80&w=2070' },
        { name: 'Cairo, Egypt', image: 'https://images.unsplash.com/photo-1539768942893-daf53e448371?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8RWd5cHR8ZW58MHx8MHx8fDA%3D' },
    ];
    const heroStyle = {
        backgroundImage: landingData ? `url(${landingData.sightSeeingBackgroundSrc})` : 'none',
    };
    const searchButtonStyle = {
        backgroundColor: landingData?.themeColor1 || '#fd5b2f', // Fallback to original orange
        borderColor: landingData?.themeColor1 || '#fd5b2f',
    };


    return (
        <>
            <div className="main-content">
                 <section className="sightseeing-hero-section" style={heroStyle}>
                     <h1 className="sightseeing-hero-title">Search and Book Activities.</h1>
                    <p className="sightseeing-hero-subtitle">Find the best activities for your next adventure</p>
                    <div className="sightseeing-search-container">
                        <SearchSightSeeingPanel />
                    </div>
                </section>

                <div className="page-content" style={{ paddingTop: 0 }}>
                    <div className="container">
                        <section ref={offersRef} className={`py-5 sightseeing-section-container ${offersInView ? 'is-visible' : ''}`}>
                            <h2 className="section-title">Exclusive Activity Offers</h2>
                            <div className="row g-4">
                                {sightseeingDeals.map((deal, index) => (
                                    <div className="col-lg-4 col-md-6" key={index}>
                                        <div className={`hotel-offer-card offer-card-${deal.type}`}>
                                            <div className="offer-card-header">
                                                <img src={deal.logoUrl} alt={`${deal.brand} logo`} className="airline-logo" />
                                                <span className="discount-badge">{deal.discount}</span>
                                            </div>
                                            <div className="offer-card-body">
                                                <h5 className="card-title">{deal.title}</h5>
                                                <p className="card-text">{deal.description}</p>
                                                <a href="#!" className="stretched-link">Book Now <i className="ri-arrow-right-line"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>

                        <section ref={destinationsRef} className={`py-5 sightseeing-section-container ${destinationsInView ? 'is-visible' : ''}`}>
                            <h2 className="section-title">Explore Popular Activities</h2>
                            <div className="row g-4">
                                {popularActivities.map((dest, index) => (
                                    <div className="col-lg-3 col-md-6" key={index}>
                                        <a href="#!" className="destination-card-modern">
                                            <img src={dest.image} alt={dest.name} className="card-img" />
                                            <div className="card-img-overlay">
                                                <h4 className="card-title">{dest.name}</h4>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchSightSeeing;